export default "__VITE_ASSET__DkE8DS20__"